/**
 * Функция для поиска хедера для запроса по тегу
 *
 * @param {{[key: string]: string} | null | undefined} params - набор кастомных хедеров
 * @param {string} paramTag - тег хедера для поиска
 *
 * @returns {{tag: string, key: string} | null} - найденный хедер
 */
export const findHeader = (params: {[key: string]: string} | null | undefined, paramTag: string) => {
    const headerParametersPairs = Object.entries(params ?? {});
    const foundPair = headerParametersPairs.find(pair => pair.includes(paramTag));

    if (foundPair) {
        return {tag: foundPair[1], key: foundPair[0]};
    }

    return null;
};
